module.exports = __webpack_public_path__ + "img/h5img49.2952b520.png";